import React from 'react'
import { TbPointFilled } from "react-icons/tb";
import classNames from 'classnames'
import styles from './styles.module.scss'



export const Radio = ({title, onChange, disabled, ...props}) => {
  const classnames = classNames(styles.radioButton, {[styles.disabled]: disabled})
  return (
    <div className={classnames} onClick={onChange}>
      <div>
        <input type='radio' {...props} hidden/>
        {!!props.checked && <TbPointFilled/>}
      </div>
      <p>{title}</p>
    </div>
  )
}


